// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kW9qG","parallax":"Footer_parallax__pnm4Z","scroller":"Footer_scroller__8gmcP"};